import Image from '@/common/components/Image/Image'
import { MarketplaceStore } from '@/queries/marketplace/schema'

type StoreCardProps = {
  store: MarketplaceStore
  handleStoreClick: (storeId: number) => void
}

const StoreCard = ({ handleStoreClick, store }: StoreCardProps) => {
  const getItemLabel = (type: string): string => {
    const numberOfItems = store.number_of_items_in_store

    if (type === 'School' || type === 'Teacher') {
      return numberOfItems === 1 ? 'Service' : 'Services'
    } else if (type === 'Shop') {
      return numberOfItems === 1 ? 'Product' : 'Products'
    }
    return numberOfItems === 1 ? 'Item' : 'Items'
  }

  return (
    <button
      onClick={() => {
        handleStoreClick(store.id)
      }}
      key={store.id}
      className="border rounded-lg shadow-lg p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300"
    >
      <div className="mb-4">
        {store.logo ? (
          <Image
            className="object-contain size-[80px] border"
            path={store.logo}
          />
        ) : (
          <div className="h-[80px] w-[80px] bg-gray-200 flex items-center justify-center text-sm text-gray-500 border">
            No image
          </div>
        )}
      </div>

      <div className="font-semibold text-gray-800 text-base mb-4">
        {store?.name}
      </div>

      <div className="text-sm text-gray-500 mb-4">
        {store?.provider_application?.business_category_name}
      </div>

      <div className="text-sm text-gray-600 font-medium border-t pt-2 w-full">
        {store.number_of_items_in_store}{' '}
        {getItemLabel(
          store?.provider_application?.business_category_name ?? ''
        )}
      </div>
    </button>
  )
}

export default StoreCard
